<button
  [type]="type"
  class="icon-btn size-{{ size }}"
  [ngClass]="{ focus: active }"
  aria-label="Search"
  role="button"
  [disabled]="disabled"
  [class.disabled]="disabled">
  <app-ce-icon [name]="iconType" [svg_class]="['d-flex', 'primary-100']"></app-ce-icon>
</button>
